// Copyright (c) 2020-2024 Omics Data Automation, Inc.
// Copyright (c) 2024 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.
import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

const performRequest = async (url, method, payload = null) => {
  try {
    const fetchParams = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + store.getters.jwt,
      },
      body: payload ? JSON.stringify(payload) : null,
    }
    const response = await fetchWithTimeout(url, fetchParams)
    const result = await response.json()
    const respObject = {
      result,
      status: response.status,
    }
    return respObject || []
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
    return []
  }
}

export const getExternalUsers = async (tbId) => {
  const queryParam = tbId ? `?tumorboard_id__eq=${tbId}` : ''
  const url = `${tumorBoardBaseUrl}/api/v2/external_attendee${queryParam}`
  return await performRequest(url, 'GET')
}

export const deleteExternalUser = async (userId) => {
  const url = `${tumorBoardBaseUrl}/api/v2/external_attendee/${userId}`
  return await performRequest(url, 'DELETE')
}

export const inviteExternalUser = async (payload) => {
  const url = `${tumorBoardBaseUrl}/api/v2/external_attendee`
  return await performRequest(url, 'POST', payload)
}

export const patchExternalUser = async (payload) => {
  const url = `${tumorBoardBaseUrl}/api/v2/external_attendee/${payload.external_attendee_id}`
  return await performRequest(url, 'PATCH', payload)
}

export const putExternalUser = async (payload) => {
  const url = `${tumorBoardBaseUrl}/api/v2/tumorboard_external_attendee/${payload.tumorboard_id}}`
  return await performRequest(url, 'PUT', payload)
}
